import { jsx as n } from "react/jsx-runtime";
import { Stack as o } from "@mui/material";
const a = (r) => {
  const { children: t } = r;
  return /* @__PURE__ */ n(
    o,
    {
      direction: "row",
      flexWrap: "wrap",
      justifyContent: "flex-end",
      gap: 2,
      padding: 3,
      ...r,
      children: t
    }
  );
};
export {
  a as DrawerActions
};
//# sourceMappingURL=index34.mjs.map
